import axios from 'axios';

let timeDeltaMillis = 0;

const plainAxios = axios.create({
  adapter: ['http', 'fetch', 'xhr']
});

async function fetchTimeDeltaMillis() {
  const rawNowMilliseconds = Date.now();
  const response = await plainAxios.get(
    `${process.env.REACT_APP_PESC_REMOTE_MONITORING_URL}/api/v2/timestamp/${rawNowMilliseconds}`
  );
  const requestTotalTimeMillis = (Date.now() - rawNowMilliseconds) / 2;

  const { deltaMillis } = response.data;
  const adjustedDeltaMillis = deltaMillis - requestTotalTimeMillis;

  console.info(`Time delta fetched (raw/adjusted): ${deltaMillis}ms/${adjustedDeltaMillis}ms`);

  return adjustedDeltaMillis;
}

export const refreshTimeDelta = async () => {
  fetchTimeDeltaMillis()
    .then((deltaMillis) => {
      timeDeltaMillis = deltaMillis;
    })
    .catch((error) => {
      console.error('Error fetching time delta:', error);
    });
};

refreshTimeDelta();

//

export const nowMilliseconds = (): number => adjustTimeOffsetMilliseconds(Date.now());

export const adjustTimeOffsetMilliseconds = (timestampInMillis: number): number =>
  timestampInMillis + timeDeltaMillis;

export const nowDate = (): Date => adjustTimeOffsetDate(new Date());

export const adjustTimeOffsetDate = (date: Date): Date =>
  new Date(date.getTime() + timeDeltaMillis);
